import * as api from 'services/api';
import { addError } from 'actions/error';

export const getEducationsDirections = () => (dispatch) =>
  api.get('education/courses/directions', 'GET_DIRECTIONS_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_DIRECTIONS_INFO_ERROR')));
    return [];
  });

export const getFilterOptions = (filters = {}) => (dispatch) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(`filters[${key}]`, v));
      } else if (typeof value === 'string' && value.includes(',')) {
        // Handle comma-separated string values
        value.split(',').forEach((v) => {
          if (v.trim()) {
            queryParams.append(`filters[${key}]`, v.trim());
          }
        });
      } else {
        queryParams.append(`filters[${key}]`, value);
      }
    }
  });
  
  const queryString = queryParams.toString();
  const url = `education/courses/filter-options${queryString ? `?${queryString}` : ''}`;
  
  return api
    .get(url, 'GET_COURSES_FILTERS_INFO', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('GET_COURSES_FILTERS_INFO_ERROR')));
      return {};
    });
};

export const getCourseById = (id) => (dispatch) =>
  api.get(`education/courses/${id}`, 'GET_COURSE_BY_ID', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_COURSE_BY_ID_ERROR')));
    return null;
  });

export const getCourseReviews =
  (courseId, { limit = 10, offset = 0 } = {}) =>
  (dispatch) =>
    api
      .get(
        `education/courses/reviews/${courseId}?limit=${encodeURIComponent(limit)}&offset=${encodeURIComponent(
          offset
        )}`,
        'GET_COURSE_REVIEWS',
        dispatch
      )
      .catch((error) => {
        dispatch(addError(new Error('GET_COURSE_REVIEWS_ERROR')));
        return [];
      });

export const addCourseReview = (courseId, data) => (dispatch) =>
  api
    .post(`education/courses/reviews/${courseId}`, data, 'ADD_COURSE_REVIEW', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('ADD_COURSE_REVIEW_ERROR')));
      return error;
    });

// Education Program reviews
export const getEducationProgramReviews =
  (programId, { limit = 10, offset = 0 } = {}) =>
  (dispatch) =>
    api
      .get(
        `education/programs/reviews/${programId}?limit=${encodeURIComponent(limit)}&offset=${encodeURIComponent(
          offset
        )}`,
        'GET_PROGRAM_REVIEWS',
        dispatch
      )
      .catch((error) => {
        dispatch(addError(new Error('GET_PROGRAM_REVIEWS_ERROR')));
        return [];
      });

export const addEducationProgramReview = (programId, data) => (dispatch) =>
  api
    .post(`education/programs/reviews/${programId}`, data, 'ADD_PROGRAM_REVIEW', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('ADD_PROGRAM_REVIEW_ERROR')));
      return error;
    });

export const getEducationProgramsFilterOptions = (filters = {}) => (dispatch) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(`filters[${key}]`, v));
      } else if (typeof value === 'string' && value.includes(',')) {
        // Handle comma-separated string values
        value.split(',').forEach((v) => {
          if (v.trim()) {
            queryParams.append(`filters[${key}]`, v.trim());
          }
        });
      } else {
        queryParams.append(`filters[${key}]`, value);
      }
    }
  });
  
  const queryString = queryParams.toString();
  const url = `education/programs/filter-options${queryString ? `?${queryString}` : ''}`;
  
  return api
    .get(url, 'GET_EDU_PROGRAMS_FILTERS_INFO', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('GET_EDU_PROGRAMS_FILTERS_INFO_ERROR')));
      return {};
    });
};

export const getEducationProgramById = (id) => (dispatch) =>
  api.get(`education/programs/${id}`, 'GET_EDU_PROGRAM_BY_ID', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_EDU_PROGRAM_BY_ID_ERROR')));
    return null;
  });

export const addCourseToFavorites = (id) => (dispatch) =>
  api
    .post(`education/courses/favorites/${id}`, {}, 'ADD_COURSE_TO_FAVORITES', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('ADD_COURSE_TO_FAVORITES_ERROR')));
    });

export const removeCourseFromFavorites = (id) => (dispatch) =>
  api
    .del(`education/courses/favorites/${id}`, {}, 'REMOVE_COURSE_FROM_FAVORITES', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('REMOVE_COURSE_FROM_FAVORITES_ERROR')));
    });

export const addEducationProgramToFavorites = (id) => (dispatch) =>
  api
    .post(`education/programs/favorites/${id}`, {}, 'ADD_EDU_PROGRAM_TO_FAVORITES', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('ADD_EDU_PROGRAM_TO_FAVORITES_ERROR')));
    });

export const removeEducationProgramFromFavorites = (id) => (dispatch) =>
  api
    .del(`education/programs/favorites/${id}`, {}, 'REMOVE_EDU_PROGRAM_FROM_FAVORITES', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('REMOVE_EDU_PROGRAM_FROM_FAVORITES_ERROR')));
    });
